import React from 'react';
import {
    Box,
    Container,
    Link,
    Typography,
    Stack
} from '@mui/material';
import { navigateToMain } from 'utilities/index';

const Footer = ({ images }) => {
    return (
        <Box
            component="footer"
            width={"100%"}
            sx={{
                position: 'relative',
                bottom: "-2rem",
                zIndex: 1,
                borderTop: "1px solid #00000014",
                paddingBlock: 2
                // marginTop: { xs: 10, md: 20 },
            }}
        >
            <Container>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        textAlign: 'center',
                    }}
                >
                    <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                        sx={{
                            marginBottom: { xs: 2, md: 0 },
                            width: '100%'
                        }}
                        id="footer-links"
                    >
                        <a
                            href={navigateToMain(null, "return") + "/privacy-policy"}
                            target="_blank" rel="noopener noreferrer"
                        >
                            Privacy Policy
                        </a>
                        <a
                            href={navigateToMain(null, "return") + "/terms-of-use"}
                            target="_blank" rel="noopener noreferrer"
                        >
                            Terms of Use
                        </a>
                        <a
                            href={navigateToMain(null, "return") + "/contact-us"}
                            target="_blank" rel="noopener noreferrer"
                        >
                            Contact Us
                        </a>
                    </Stack>

                    <Typography
                        variant="body2"
                        color="black"
                        sx={{
                            margin: 0,
                            width: '100%'
                        }}
                    >
                        ©{new Date().getFullYear()} Backrr. All Rights Reserved
                    </Typography>
                </Box>
            </Container>

            {/* Background Shapes
      {images && (
        <>
          <Box
            component="img"
            src={images.shape_1}
            alt=""
            sx={{
              position: 'absolute',
              zIndex: -1,
              // Adjust positioning as needed
              top: 0,
              left: 0,
            }}
          />
          <Box
            component="img"
            src={images2}
            alt=""
            sx={{
              position: 'absolute',
              zIndex: -1,
              // Adjust positioning as needed
              bottom: 0,
              right: 0,
            }}
          />
        </>
      )} */}
        </Box>
    );
};

export default Footer;